import React, { useEffect, useState } from 'react';
import type { Ctx } from '../ctx';
import { Icon } from '../icons';

/** Prima pagina di Licenze: un riquadro per ogni programma, con un clic si aprono le sue licenze. */
export function LicensesHomePage({ ctx }: { ctx: Ctx }) {
  const [racing, setRacing] = useState<number | null>(null);
  const [sentinel, setSentinel] = useState<number | null>(null);

  useEffect(() => {
    ctx.api.get<{ licenses: unknown[] }>('/api/racing/licenses').then((r) => setRacing(r.licenses.length)).catch(() => undefined);
    ctx.api.get<{ sites: unknown[] }>('/api/guard/sites').then((r) => setSentinel(r.sites.length)).catch(() => undefined);
  }, [ctx.api]);

  const tiles = [
    { page: 'licenses', title: 'SlipAngle', text: 'Il gioco di guida: chi può giocare e su quanti PC.', count: racing, unit: 'licenze' },
    { page: 'licenses-nis2', title: 'Sentinel', text: 'Il programma di sicurezza per le aziende clienti.', count: sentinel, unit: 'aziende' },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16 }}>
      {tiles.map((t) => (
        <button key={t.page} type="button" className="panel" title={`Apri le licenze di ${t.title}`} onClick={() => ctx.setPage(t.page)}
          style={{ textAlign: 'left', cursor: 'pointer', padding: 28, minHeight: 170, border: 'none', font: 'inherit', color: 'inherit' }}>
          <Icon name="key" size={26} />
          <div style={{ fontSize: 22, fontWeight: 700, marginTop: 12 }}>{t.title}</div>
          <div className="muted small" style={{ marginTop: 4 }}>{t.text}</div>
          <div style={{ marginTop: 14, fontWeight: 600 }}>{t.count === null ? ' ' : `${t.count} ${t.unit}`}</div>
        </button>
      ))}
    </div>
  );
}
